/* JS for complementary/suggested product popup for the product page */
document.addEventListener('DOMContentLoaded', function () {
  var popup = document.querySelector('[data-complementary-popup]');
  if (!popup) return; // no complementary products on this product

  var dialog = popup.querySelector('.complementary-popup__dialog');
  var closeButtons = popup.querySelectorAll('[data-complementary-popup-close]');
  var productForm = document.querySelector('form[action^="/cart/add"]');
  var addButtons = document.querySelectorAll(
    'form[action^="/cart/add"] [type="submit"], ' +
    'form[action^="/cart/add"] button[name="add"]'
  );
  var popupAddForms = popup.querySelectorAll('form[action^="/cart/add"]');
  var showScheduled = false;

  function closePopup() {
    popup.classList.remove('is-visible');
    document.body.classList.remove('complementary-popup-open');
  }

  function maybeShowPopupFromCart(cart) {
    var idsInCart = cart.items.map(function (item) {
      return item.product_id;
    });

    var groups = popup.querySelectorAll('[data-complementary-product-id]');
    var visibleCount = 0;

    groups.forEach(function (group) {
      var pid = parseInt(group.getAttribute('data-complementary-product-id'), 10);
      if (idsInCart.indexOf(pid) !== -1) {
        group.style.display = 'none';
      } else {
        group.style.display = '';
        visibleCount++;
      }
    });

    if (visibleCount > 0) {
      popup.classList.add('is-visible');
      document.body.classList.add('complementary-popup-open');
      if (dialog) dialog.focus();
    } else {
      // If everything is already in the cart, make sure popup is closed
      closePopup();
    }
  }

  function fetchCartAndMaybeShow() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(maybeShowPopupFromCart)
      .catch(function (e) {
        console.error('Complementary popup cart error', e);
      });
  }

  function schedulePopup() {
    if (showScheduled) return;
    showScheduled = true;
    setTimeout(function () {
      showScheduled = false;
      fetchCartAndMaybeShow();
    }, 500);
  }

  // Main product add-to-cart → schedule popup check
  if (productForm) {
    productForm.addEventListener('submit', function () {
      schedulePopup();
    });
  }

  addButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      schedulePopup();
    });
  });

  // Bulb add-to-cart inside popup → close immediately
  popupAddForms.forEach(function (form) {
    form.addEventListener('submit', function () {
      closePopup();
    });
  });

  // Close handlers: X button + "No thanks" button
  closeButtons.forEach(function (btn) {
    btn.addEventListener('click', closePopup);
  });

  // Click outside dialog closes popup
  popup.addEventListener('click', function (e) {
    if (e.target === popup) {
      closePopup();
    }
  });

  // Escape key closes popup
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.classList.contains('is-visible')) {
      closePopup();
    }
  });
});
